import React from 'react';
import Match from 'react-router/Match';
import AccountMain from './AccountMain';
import AccountSubscription from './AccountSubscription';

const Account = (props) => {
  if (!props.auth.isAuthenticated) { return <span />; }

  return (
    <div>
      <Match exactly pattern="/account/subscription" render={componentProps => <AccountSubscription {...componentProps} {...props} />} />
      <Match exactly pattern="/account" render={componentProps => <AccountMain {...componentProps} {...props} />} />
    </div>
    );
};

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account.js